var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7763 0H39.2266V82H42.7763V0Z",
    fill: "#f5801b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39.2246H0V42.7744H82V39.2246Z",
    fill: "#f5801b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39.2246H0V42.7744H82V39.2246Z",
    fill: "#f5801b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2718 10.7439L10.7617 13.2539L68.7439 71.2361L71.254 68.7261L13.2718 10.7439Z",
    fill: "#f5801b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7439 10.7444L10.7617 68.7266L13.2718 71.2366L71.254 13.2544L68.7439 10.7444Z",
    fill: "#f5801b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4096 3.03395L22.1875 4.52344L56.5947 78.9548L59.8168 77.4653L25.4096 3.03395Z",
    fill: "#f5801b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4943 1.89261L25.1797 78.8496L28.5112 80.0753L56.8258 3.11835L53.4943 1.89261Z",
    fill: "#f5801b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4748 22.1893L3.03516 56.5801L4.52394 59.8026L78.9635 25.4118L77.4748 22.1893Z",
    fill: "#f5801b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13554 25.1724L1.91016 28.5039L78.8672 56.8103L80.0925 53.4788L3.13554 25.1724Z",
    fill: "#f5801b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/orangeStar.94747d4e36c6041f607f43f1988f5140.svg";
export { ForwardRef as ReactComponent };